export const SORT_TEXT = "Sort";
export const RECOMMENDED_TEXT = "Recommended";
export const RATING_TEXT = "Star Rating (High to Low)";
export const PRICE_PER_NIGHT_TEXT = "Price (Low to High)";

export const CHOOSE_SORT_OPTION_TEXT = "Choose a Sort Option";
export const CHANGE_SORT_OPTION_TEXT = "Change Sort Option";
